import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { array } from 'prop-types';
import FaqSearchResultsItem from './FaqSearchResultsItem';

class FaqSearchResults extends PureComponent {
  static propTypes = {
    results: array.isRequired,
  };

  static defaultProps = {
    results: [],
  };

  render() {
    const { results } = this.props;

    return (
      <div className="faq-search-results-container">
        {results.length > 0 ? (
          results.map(result => <FaqSearchResultsItem key={result.id} {...result} />)
        ) : (
          <FormattedMessage id="faq.search.no-result" defaultMessage="No results" />
        )}
      </div>
    );
  }
}

export default FaqSearchResults;
